import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';

export default function ProjectShowcase() {
  const { t } = useLanguage();
  const [activeTab, setActiveTab] = useState('all');

  const filteredProjects =
    activeTab === 'all'
      ? t.projects
      : t.projects.filter((p) => p.categoryKey === activeTab);

  const handleMouseMove = (e) => {
    const card = e.currentTarget;
    const rect = card.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    card.style.setProperty('--mouse-x', `${x}px`);
    card.style.setProperty('--mouse-y', `${y}px`);
  };

  return (
    <section className="section-wrapper reveal-on-scroll" id="projeler">
      <div className="container">
        <div className="section-header-neo">
          <div>
            <div className="neo-tag-pill">
              <span>[ {t.ui.workLabel} ]</span>
            </div>
            <h2 className="neo-section-title">{t.ui.workTitle}</h2>
          </div>
          <p className="neo-section-sub">{t.ui.workSubtitle}</p>
        </div>

        {/* Category Filters */}
        <div className="filter-tabs-neo" role="tablist">
          {t.projectCategories.map((cat) => (
            <button
              key={cat.key}
              type="button"
              role="tab"
              aria-selected={activeTab === cat.key}
              className={`tab-btn-neo ${activeTab === cat.key ? 'active' : ''}`}
              onClick={() => setActiveTab(cat.key)}
            >
              [ {cat.label} ]
            </button>
          ))}
        </div>

        {/* Projects Neobrutalist Grid */}
        <div className="projects-neo-grid">
          {filteredProjects.map((project, idx) => (
            <article
              key={project.id}
              className={`project-neo-card spotlight-card ${project.id === 'vault' ? 'featured' : ''}`}
              onMouseMove={handleMouseMove}
              style={{ animationDelay: `${idx * 0.1}s` }}
            >
              <div className="card-neo-header">
                <span className="neo-tag-pill" style={{ background: '#0a0b0e', borderColor: '#282d3b' }}>
                  {project.categoryLabel}
                </span>
                <span style={{ fontFamily: 'var(--font-mono)', fontWeight: 700, color: '#ccff00' }}>
                  [SPEC-0{idx + 1} {'//'} {project.year}]
                </span>
              </div>

              <div>
                <h3 className="card-neo-title">{project.title}</h3>
                <div className="card-neo-tagline">{project.tagline}</div>
              </div>

              <p className="card-neo-desc">{project.description}</p>

              {project.highlights && project.highlights.length > 0 && (
                <ul className="card-neo-bullets">
                  {project.highlights.map((bullet, bulletIdx) => (
                    <li key={bulletIdx}>
                      <span>{bullet}</span>
                    </li>
                  ))}
                </ul>
              )}

              <div className="card-neo-footer">
                <div className="card-neo-stack">
                  {project.stack.map((tech) => (
                    <span
                      key={tech}
                      className="neo-tag-pill tag-spring"
                      style={{ fontSize: '0.76rem', padding: '0.2rem 0.55rem' }}
                    >
                      {tech}
                    </span>
                  ))}
                </div>

                <a
                  href={project.github}
                  target="_blank"
                  rel="noreferrer"
                  className="btn-neo btn-neo-chrome btn-sweep"
                  style={{ padding: '0.45rem 0.95rem', fontSize: '0.82rem' }}
                >
                  <i className="fa-brands fa-github"></i>
                  <span>{t.ui.inspectSource}</span>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
